var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineColorfilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 16c0-3.04 2.04-5.72 4.97-6.51.37-.1.75.09.89.45.61 1.53 1.91 2.7 3.5 3.13.88.24 1.9.24 2.76 0 .37-.1.76.09.9.45.31.79.47 1.63.47 2.49 0 1.92-.82 3.75-2.25 5.02A6.708 6.708 0 0 1 8 22.75c-3.72 0-6.75-3.03-6.75-6.75zm1.5 0c0 2.89 2.36 5.25 5.25 5.25 1.3 0 2.54-.48 3.5-1.35a5.196 5.196 0 0 0 1.75-3.9c0-.46-.06-.9-.17-1.33-.94.15-1.96.1-2.86-.15a6.816 6.816 0 0 1-4.2-3.39c-1.95.8-3.27 2.72-3.27 4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.22 14.51a6.809 6.809 0 0 1-4.5-4.03C5.41 9.7 5.25 8.86 5.25 8c0-3.72 3.03-6.75 6.75-6.75S18.75 4.28 18.75 8c0 .86-.16 1.7-.47 2.49a6.811 6.811 0 0 1-4.5 4.03c-.56.15-1.16.23-1.78.23-.62 0-1.22-.08-1.78-.24zM6.75 8c0 .67.12 1.32.37 1.93.61 1.53 1.91 2.7 3.5 3.13.88.24 1.9.24 2.76 0 1.59-.43 2.9-1.61 3.5-3.13.24-.61.37-1.26.37-1.93 0-2.89-2.36-5.25-5.25-5.25S6.75 5.11 6.75 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.02a.75.75 0 0 1 0-1.12 5.2 5.2 0 0 0 1.75-3.9c0-.67-.12-1.32-.37-1.93-.08-.2-.07-.42.03-.61s.27-.33.47-.39c1.59-.43 2.89-1.6 3.5-3.13.14-.36.53-.54.89-.45 2.93.8 4.97 3.47 4.97 6.51.01 3.72-3.02 6.75-6.74 6.75-1.67 0-3.27-.62-4.5-1.73zm4.5.23c2.89 0 5.25-2.36 5.25-5.25 0-2.15-1.32-4.07-3.27-4.87a6.82 6.82 0 0 1-3.46 3.13c.15.56.23 1.15.23 1.74 0 1.62-.58 3.18-1.63 4.39.85.56 1.84.86 2.88.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineColorfilter);
export default __webpack_public_path__ + "static/media/vuesax-outline-colorfilter.dcdc3d09fc279d11397806a727d841bd.svg";
export { ForwardRef as ReactComponent };